/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useState } from "react";
import { useHistory } from "react-router-dom";
import Modal from "react-modal";
import axios from "axios";
import { Timer, PromoGiftBox } from "@tomocredit/common-fe/components";
import { isValidEmail } from "@tomocredit/common-fe/utils";
import { LEAD_SOURCES } from "@tomocredit/common-fe/consts";
import { PromoContext } from "./common";

const modalStyle = {
  overlay: {
    zIndex: 50,
    backgroundColor: "#00000080", // black with a bit of transparency
  },
  content: {
    position: "absolute",
    zIndex: 100,
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    border: 0,
    background: "rgb(255, 255, 255)",
    overflow: "auto",
    borderRadius: "10px",
    outline: "none",
    transform: "translate(-50%, -50%)",
    maxWidth: "500px",
    boxShadow:
      "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
  },
};

const BoostPopupModal = ({ email, isOpen, closeModal }) => {
  const [formEmail, setFormEmail] = useState(email || "");
  const [emailError, setEmailError] = useState("");
  const [productEnrolled, setProductEnrolled] = useState(false);
  const [loading, setLoading] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const { promoInfo } = useContext(PromoContext);

  if (promoInfo.showCountDown) {
    modalStyle.content.maxWidth = "600px";
  }

  const history = useHistory();
  const handleEmailInput = (e) => {
    const emailInput = (e.target?.value?.trim() || "").toLowerCase();
    setFormEmail(emailInput);
    setProductEnrolled(false);
    setEmailError("");
  };

  const handleSubmit = async () => {
    if (loading) {
      return;
    }
    setEmailError(null);
    // no email flow
    if (!email) {
      if (!formEmail || !isValidEmail(formEmail)) {
        setEmailError("Please enter a valid email");
        return;
      }
      setLoading(true);
      let signUpBoostRes;
      try {
        const payload = { email: formEmail, source: LEAD_SOURCES.BOOST_POPUP };
        signUpBoostRes = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/boost/signup`,
          payload,
        );
      } catch (err) {
        setEmailError(
          "Could not communicate with server. Please try again later",
        );
        return;
      } finally {
        setLoading(false);
      }
      const { boostEnrolled, userExists } = signUpBoostRes?.data ?? {};
      if (boostEnrolled) {
        setEmailError("You are already enrolled.");
        setProductEnrolled(true);
        return;
      }

      window.fbq?.("track", "Lead");
      window.gtag?.({
        event: "Lead",
        email: formEmail,
      });
      if (!userExists) {
        window?.gtag?.("event", "boost_popup_new_signup", {
          email,
        });
      }
      urlParams.set("email", formEmail);
    }
    urlParams.set("referralCode", "BOOST10");
    const newUrl = `/boost-pricing?${urlParams.toString()}`;
    history.push(newUrl);
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel="Boost Popup Modal"
      style={modalStyle}
      ariaHideApp={false}
    >
      <div
        style={{ minWidth: 350 }}
        className="w-full h-full flex flex-col justify-center items-center text-black fade"
      >
        <div className="w-full" style={{ backgroundColor: "#F1EDFE" }}>
          <div
            style={{
              width: 25,
              height: 25,
            }}
            className="mt-4 mr-4 flex justify-center items-center absolute text-center text-black bg-gray-400 border rounded-full top-0 right-0 cursor-pointer text-4xl px-2 leading-none"
            onClick={closeModal}
          >
            &times;
          </div>
          <div className="flex justify-center py-4">
            <PromoGiftBox />
          </div>
        </div>
        <div className="py-6 px-8">
          {promoInfo.showCountDown && (
            <div className="flex flex-col justify-content-center xs:gap-1 sm:gap-2 mb-5 px-3">
              <div className="text-center xs:font-bold font-semibold xs:text-base text-xl">
                {promoInfo.text}
              </div>
              <Timer boxClass="bg-gray-100" deadline={promoInfo.deadline} />
            </div>
          )}
          <div className="text-center text-black my-auto font-medium xs:text-sm md:text-lg">
            Get{" "}
            <span className="text-boost-primary-purple font-semibold">
              10% off
            </span>{" "}
            your next purchase!
          </div>
          <div className="flex xs:flex-col sm:flex-row justify-center items-center mt-4">
            {!email && (
              <input
                style={{ minWidth: 300 }}
                placeholder="Enter Email"
                className="same-host-redirect py-3 px-2 placeholder-gray-600 text-black text-lg w-full leading-none outline-none bg-white border-black border xs:rounded-l-lg xs:rounded-r-lg sm:rounded-r-none xs:min-w-full"
                onChange={handleEmailInput}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleSubmit();
                  }
                }}
                value={formEmail}
              />
            )}
            <button
              type="button"
              className="same-host-redirect py-2 xs:my-2 xs:w-full sm:w-2/5 sm:py-3 sm:whitespace-nowrap px-2 bg-boost-primary-purple text-white font-semibold xs:rounded-lg sm:rounded-l-none"
              onClick={handleSubmit}
            >
              GET 10% OFF
            </button>
          </div>
          <div className="flex flex-col sm:flex-row">
            {emailError && <div className="text-red-500">{emailError}</div>}
            {productEnrolled && (
              <div className="text-stripe-error-red flex whitespace-pre flex-wrap">
                <span> Click </span>
                <a
                  href={`${process.env.REACT_APP_DOMAIN}/dashboard/login?redirect_uri=/boost&fromBoost=true`}
                  onClick={(e) => e.currentTarget.focus()}
                  className="same-host-redirect"
                >
                  <p
                    className="hover:underline text-black"
                    style={{ fontWeight: 400 }}
                  >
                    here
                  </p>
                </a>
                <span> to log in.</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default BoostPopupModal;
